import {
  Box,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  useDisclosure,
} from '@chakra-ui/react';

import { MobileNav } from '../mobile-nav/mobile-nav';
import { SidebarContent } from '../side-bar-content/side-bar-content';

export interface ISideBarProps {
  collapsed: boolean;
  handleCollapse: () => void;
  appLastUpdated?: string;
  appReleaseVersion?: string;
}

export const SideBar = ({
  collapsed,
  handleCollapse,
  appLastUpdated,
  appReleaseVersion,
}: ISideBarProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box as="nav" zIndex="docked">
      <SidebarContent
        display={{ base: 'none', md: 'flex' }}
        collapsed={collapsed}
        handleCollapse={handleCollapse}
        top={0}
        appLastUpdated={appLastUpdated}
        appReleaseVersion={appReleaseVersion}
      />
      <Drawer
        autoFocus={false}
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        onOverlayClick={onClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <SidebarContent
            onClose={onClose}
            appLastUpdated={appLastUpdated}
            appReleaseVersion={appReleaseVersion}
          />
        </DrawerContent>
      </Drawer>
      <MobileNav onOpen={onOpen} />
    </Box>
  );
};
